// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wb_a bhp_b bhp_we"};